import React from "react";
var __jsx = React.createElement;
import SecondaryPageHero from './SecondaryPageHero';
function SecondaryPageHeroAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(SecondaryPageHero, {
    heroData: entry,
    shouldPreloadImage: data.shouldPreloadImage,
    scrollbarWidth: data.scrollBarWidth,
    className: "secondary-hero"
  });
}
export default SecondaryPageHeroAdapter;